import { getCookie, setCookie } from "../cookies/cookies";
import { isVerifiedOfflineAvVariant } from "../offlineRegistration/offlineRegistration";
export const IS_AGE_CONFIRMED_COOKIE_NAME = "isAgeConfirmed";
export const isAutoConfirmAgeVerificationEnabled = () => {
    // can be extended with more conditions if needed in future
    return isVerifiedOfflineAvVariant();
};
export const isSoftAgeVerificationConfirmed = () => {
    return getCookie(IS_AGE_CONFIRMED_COOKIE_NAME);
};
export const confirmSoftAgeVerification = () => {
    setCookie(IS_AGE_CONFIRMED_COOKIE_NAME, true, "/");
};
export const initAutoConfirmAgeVerification = () => {
    if (isAutoConfirmAgeVerificationEnabled()) {
        confirmSoftAgeVerification();
    }
};
//# sourceMappingURL=hiddenSoftAv.js.map